const Copyright = () => {
    return (
        <div className="text-center py-2 text-white copyright">
            © 2025 Sheel Waterproofing Nepal Pvt. Ltd. All rights reserved.
        </div>
    );
};

export default Copyright;
